export default __webpack_public_path__ + "static/media/serbgo-logo.655abe0d.png";